"use client";

import AwesomeCard from "@/components/common/awesome-card";
import CiInteractiveMap, { ciInteractiveMapMarkers } from "@/components/site-officiel/accueil/ci-interactive-map";
import { useNavigate } from "react-router-dom";

function DecouvrirCiCard() {
    const navigate = useNavigate();

    return (<AwesomeCard title={"Découvrir la Côte d'Ivoire"} className={"bg-bleu-marine"} titleClassName={"text-white"}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-4">
            <div className={"text-white md:pt-12"}>
                {`La Côte d’Ivoire, officiellement République de Côte d’Ivoire (RCI), est un État situé en Afrique, dans
                 la partie occidentale du golfe de Guinée. Elle présente sensiblement la forme d’un carré d’environ 600
                  kilomètres de côté. D’une superficie de 322 462 km2, elle est bordée au nord-ouest par le Mali, au 
                  nord-est par le Burkina Faso, à l’est par le Ghana, au sud-ouest par le Liberia, à l’ouest-nord-ouest
                   par la Guinée et au sud par l’océan Atlantique.`}
            </div>
            <div className={"flex justify-center"}>
               {/*<MapViewer />*/}
                <CiInteractiveMap strokeColor={"#004c75"} markers={ciInteractiveMapMarkers(navigate)} />
            </div>
        </div>
    </AwesomeCard>)
}



export default DecouvrirCiCard;
